import AbstractController from '../../../services/abstractController';
import LoginService from '../../../../app/services/LoginService';
import AuthService from '../../../services/authService';
import LoginFilter from '../model/LoginFilter';
import ToastService from '../../../services/toastService';
import ContribuinteService from '../../../../app/services/contribuinte.service';

export default class LoginController extends AbstractController {
  private loginService = new LoginService();

  private authService = new AuthService();

  private contribuinteService = new ContribuinteService();

  constructor(private readonly loginFilter: LoginFilter) {
    super();
  }

  init() {
    this.authService.remove();
    super.init();
  }

  async logar() {
    if (
      !this.loginFilter.usuario ||
      this.loginFilter.usuario.length === 0 ||
      (!this.loginFilter.senha && this.loginFilter.senha.length === 0)
    ) {
      return ToastService.showError('Informe o Login da rede e a Senha');
    }
    try {
      this.blockUIService.start();
      const data: any = await this.loginService.login(
        this.loginFilter.usuario,
        this.loginFilter.senha,
      );
      if (data.success) {
        const user = data.result;
        this.authService.save(user);
        window.location.href = '/';
      } else {
        ToastService.showError(data.result[0]);
      }
    } catch (err: any) {
    }
    this.blockUIService.stop();
  }
}
